import React from 'react';
export const Row = ({ children, }) => {
    return React.createElement("div", { className: "row" }, children);
};
export const Column = ({ width, lg, children, }) => {
    return React.createElement("div", { className: `col-${width} col-lg-${lg || width}` }, children);
};
